const getValue = (key, defaultValue) => {
  try {
    return JSON.parse(localStorage.getItem(key)) || defaultValue
  } catch (e) {
    return defaultValue
  }
}

export default getValue
